<template>
  <div>
    <Title class="center-title">员工瓴云账号信息填写表</Title>

    <!-- 节点为 creator_confirm 时，醒目展示登录账号与初始密码 -->
    <div v-if="isCreatorConfirm" class="account-banner">
      <div class="account-banner-title">员工登录账号信息</div>
      <div class="account-banner-item">
        登录账号：
        <span class="account-highlight">{{ text(extra.mobile) }}</span>
        <span class="account-label">（手机号）</span>
        <span class="account-divider">/</span>
        <span class="account-highlight">{{ text(extra.code) }}</span>
        <span class="account-label">（门户账号）</span>
      </div>
      <div class="account-banner-item">
        初始密码：
        <span class="account-highlight">{{ defaultPassword }}</span>
      </div>
    </div>

    <!-- 一、申请人基本信息 -->
    <div class="section-title">一、申请人基本信息</div>
    <div class="panel">
      <div class="label">申请类型</div>
      <div class="value3">{{ applicationTypeText(extra.applicationType) }}</div>
      
      <div class="label">姓名</div>
      <div class="value1">{{ text(extra.name) }}</div>
      <div class="label">性别</div>
      <div class="value2">{{ findName(sex, extra.sex) }}</div>

      <div class="label">曾用名</div>
      <div class="value1">{{ text(extra.oldName) }}</div>
      <div class="label">入职日期</div>
      <div class="value2">{{ dateText(extra.entryDate) }}</div>

      <div class="label">出生日期</div>
      <div class="value1">{{ dateText(extra.birthday) }}</div>
      <div class="label">年龄</div>
      <div class="value2">{{ ageText(extra.birthday) }}</div>

      <div class="label">国籍(地区)</div>
      <div class="value1">{{ text(extra.nationality) }}</div>
      <div class="label">民族</div>
      <div class="value2">{{ text(extra.ethnicGroup) }}</div>

      <div class="label">政治面貌</div>
      <div class="value1">{{ findName(politicalOutlookList, extra.political) }}</div>
      <div class="label">入党/团日期</div>
      <div class="value2">{{ dateText(extra.politicalDate) }}</div>
    </div>

    <!-- 二、权限信息 -->
    <div class="section-title">二、权限信息</div>
    <div class="panel">
      <div class="label">权限需求描述</div>
      <div class="value3">{{ text(extra.permissionDescription) }}</div>
    </div>

    <!-- 三、证件信息 -->
    <div class="section-title">三、证件信息</div>
    <div class="panel">
      <div class="label">证件类型</div>
      <div class="value1">{{ findName(credentialType, extra.credentialType) }}</div>
      <div class="label">证件截止日期</div>
      <div class="value2">{{ dateText(extra.credentialExpireDate) }}</div>

      <div class="label">证件号码</div>
      <div class="value3">{{ text(extra.credentialNumber) }}</div>
    </div>

    <!-- 四、户籍与居住信息 -->
    <div class="section-title">四、户籍与居住信息</div>
    <div class="panel">
      <div class="label">籍贯</div>
      <div class="value1">{{ text(extra.nativePlace) }}</div>
      <div class="label">户口类型</div>
      <div class="value2">{{ findName(registerResidenceType, extra.registerResidenceType) }}</div>

      <div class="label">户籍地址</div>
      <div class="value3">{{ text(extra.registerResidenceAddress) }}</div>
      
      <div class="label">出生地</div>
      <div class="value1">{{ text(extra.birthplace) }}</div>
      <div class="label">家庭地址</div>
      <div class="value2">{{ text(extra.address) }}</div>

      <div class="label">办公地址</div>
      <div class="value3">{{ text(extra.addressWork) }}</div>
    </div>

    <!-- 五、档案信息 -->
    <div class="section-title">五、档案信息</div>
    <div class="panel">
      <div class="label">档案所在地</div>
      <div class="value3">{{ text(extra.archiveLocation) }}</div>

      <div class="label">档案存档机构</div>
      <div class="value3">{{ text(extra.archiveAgency) }}</div>
    </div>

    <!-- 六、职业与教育背景 -->
    <div class="section-title">六、职业与教育背景</div>
    <div class="panel">
      <div class="label">最高学历</div>
      <div class="value1">{{ findName(degree, extra.degree) }}</div>
      <div class="label">专业特长</div>
      <div class="value2">{{ text(extra.expertises) }}</div>

      <div class="label">参加工作日期</div>
      <div class="value1">{{ dateText(extra.workStartTime) }}</div>
      <div class="label">工号</div>
      <div class="value2">{{ text(extra.workNo) }}</div>

      <div class="label">部门</div>
      <div class="value1">{{ text(extra.deptName) }}</div>
      <div class="label">岗位</div>
      <div class="value2">{{ findName(positionList, extra.post) }}</div>
    </div>

    <!-- 七、联系方式 -->
    <div class="section-title">七、联系方式</div>
    <div class="panel">
      <div class="label">手机号码</div>
      <div class="value1">{{ text(extra.mobile) }}</div>
      <div class="label">办公电话</div>
      <div class="value2">{{ text(extra.phone) }}</div>

      <div class="label">公司邮箱</div>
      <div class="value1">{{ text(extra.email) }}</div>
      <div class="label">个人邮箱</div>
      <div class="value2">{{ text(extra.emailIndividual) }}</div>

      <div class="label">门户账号</div>
      <div class="value3">{{ text(extra.code) }}</div>
    </div>

    <!-- 八、家庭与社会关系 -->
    <div class="section-title">八、家庭与社会关系</div>
    <div class="panel">
      <div class="label">婚姻状况</div>
      <div class="value1">{{ findName(marrigeStatus, extra.marryType) }}</div>
      <div class="label">子女状况</div>
      <div class="value2">{{ findName(childStatus, extra.childrenType) }}</div>

      <div class="label">紧急联系人姓名</div>
      <div class="value1">{{ text(extra.emergencyContact) }}</div>
      <div class="label">紧急联系人关系</div>
      <div class="value2">{{ text(extra.emergencyContactRelation) }}</div>

      <div class="label">紧急联系人电话</div>
      <div class="value3">{{ text(extra.emergencyContactMobile) }}</div>
    </div>

    <Padding />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Title from "../../Title";
import moment from "moment";

export default {
  components: { Title },
  data() {
    return {
      // 员工初始密码（与后端创建账号时一致）
      defaultPassword: "szsj88888888",
    };
  },
  computed: {
    ...mapState("approval", ["detail"]),
    ...mapGetters("setting", ["findDataDict"]),
    extra() {
      return this.detail && this.detail.extra ? this.detail.extra : {};
    },
    // 当前审批节点为 creator_confirm（申请人确认）时展示账号信息
    isCreatorConfirm() {
      return (
        this.detail && this.detail.taskDefinitionKey === "creator_confirm"
      );
    },
    lists() {
      return this.findDataDict("talentMap");
    },
    sex() {
      return this.findDataDict("sex");
    },
    politicalOutlookList() {
      return this.findDataDict("politicalOutlook");
    },
    degree() {
      return this.findDataDict("degree");
    },
    positionList() {
      const item = (this.lists || []).find(
        (it) => it.value === "talentMap_post"
      );
      return item ? item.children : [];
    },
    credentialType() {
      const item = (this.lists || []).find(
        (it) => it.value === "credentialType"
      );
      return item ? item.children : [];
    },
    registerResidenceType() {
      const item = (this.lists || []).find(
        (it) => it.value === "registerResidenceType"
      );
      return item ? item.children : [];
    },
    marrigeStatus() {
      const item = (this.lists || []).find(
        (it) => it.value === "marrigeStatus"
      );
      return item ? item.children : [];
    },
    childStatus() {
      const item = (this.lists || []).find(
        (it) => it.value === "childStatus"
      );
      return item ? item.children : [];
    },
  },
  methods: {
    text(v) {
      return v === undefined || v === null || v === "" ? "—" : v;
    },
    findName(list, value) {
      if (value === undefined || value === null || value === "") return "—";
      const item = (list || []).find((it) => it.value === value);
      return item ? item.name : value;
    },
    dateText(v) {
      if (!v) return "—";
      return moment(v).format("YYYY-MM-DD");
    },
    // 根据出生日期计算年龄（与 form.vue 的 getDateLength 一致）
    ageText(v) {
      if (!v) return "—";
      const m = moment(v);
      if (!m.isValid()) return "—";
      return new Date().getFullYear() - parseInt(m.format("YYYY"));
    },
    applicationTypeText(v) {
      const map = { add: "新增", update: "变更", leave: "注销" };
      return map[v] || (v ? v : "—");
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .center-title {
  font-size: 24px;
  left: 0;
  text-align: center;
  margin-top: -65px;
  margin-bottom: 30px;
  margin-left: 150px;

  &::before {
    display: none;
  }
}

.section-title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin: 16px 0 8px;
}

.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}

/* 账号信息醒目提示框 */
.account-banner {
  background: linear-gradient(135deg, #fff7e6 0%, #fff1b8 100%);
  border: 2px solid #fa8c16;
  border-radius: 6px;
  padding: 16px 24px;
  margin: 16px 0 8px;
  box-shadow: 0 2px 8px rgba(250, 140, 22, 0.15);

  .account-banner-title {
    font-size: 18px;
    font-weight: bold;
    color: #d4380d;
    margin-bottom: 10px;
  }

  .account-banner-item {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 2;
  }

  .account-highlight {
    font-size: 18px;
    font-weight: bold;
    color: #d4380d;
    letter-spacing: 1px;
  }

  .account-label {
    color: rgba(0, 0, 0, 0.45);
    font-size: 13px;
  }

  .account-divider {
    margin: 0 12px;
    color: rgba(0, 0, 0, 0.25);
  }
}
</style>
